import { apiClient } from "./api";

/**
 * The agent releases currently published to the apt repository
 * (apt.insaion.com). The API reads the repository's package indexes, so this is
 * the same source of truth a robot's `apt upgrade` uses.
 */
export interface AgentReleaseInfo {
  /** Newest upstream version across every suite, e.g. "0.10.2". */
  latest_version: string;
  /**
   * Package name -> Ubuntu suite -> exact Debian version, e.g.
   * packages["ros-humble-insaion-agent"]["jammy"] === "0.10.2-0jammy".
   */
  packages: Record<string, Record<string, string>>;
  /**
   * Where the answer came from. "fallback" means the repository was
   * unreachable and the API had nothing cached, so the version may be behind.
   */
  source: "apt" | "cache" | "fallback";
  fetched_at: string;
}

export const getAgentReleases = async (): Promise<AgentReleaseInfo> => {
  const response = await apiClient.get<AgentReleaseInfo>("/agent/releases");
  return response.data;
};
